// Import the notifications API
import { notificationsAPI } from './api';

// Service for handling notification operations
const NotificationService = {
  /**
   * Send notifications to participants of a hearing
   * @param {Object} data - The notification data
   * @param {string} data.disputeId - The ID of the dispute
   * @param {string} data.notificationType - Type of notification (sms, email, both, none)
   * @param {string} data.hearingDate - Date of the hearing
   * @param {string} data.hearingTime - Time of the hearing
   * @param {string} data.location - Location of the hearing
   * @param {string} data.additionalNotes - Additional notes for the notification
   * @returns {Promise} - The notification send result
   */
  sendHearingNotifications: async (data) => {
    try {
      const response = await notificationsAPI.sendHearingNotifications(data);
      return response.data;
    } catch (error) {
      console.error('Error sending hearing notifications:', error);
      throw error;
    }
  },

  /**
   * Get notification delivery status
   * @param {string} notificationId - ID of the notification to check
   * @returns {Promise} - The notification status
   */
  getNotificationStatus: async (notificationId) => {
    try {
      const response = await notificationsAPI.getStatus(notificationId);
      return response.data;
    } catch (error) {
      console.error('Error getting notification status:', error);
      throw error;
    }
  },

  /**
   * Get all notifications for a dispute
   * @param {string} disputeId - ID of the dispute
   * @returns {Promise} - The dispute notifications
   */
  getDisputeNotifications: async (disputeId) => {
    try {
      const response = await notificationsAPI.getDisputeNotifications(disputeId);
      return response.data;
    } catch (error) {
      console.error('Error getting dispute notifications:', error);
      throw error;
    }
  }
};

export default NotificationService;
